import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    navigate(-1);
  };

  // דפים שבהם לא להציג חץ אחורה
  const hiddenPaths = ['/', '/login', '/register'];
  
  // אם אנחנו בדף שלא צריך חץ אחורה, לא להציג
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <IconButton
      onClick={handleGoBack}
      sx={{
        color: 'black',
        position: 'fixed',
        top: 74,  // 10px מתחת לגובה הרגיל של AppBar
        left: 16,
        zIndex: 1100,
      }}
    >
      <ArrowForwardIcon />
    </IconButton>
  );
};

export default BackButton;